<template>
	<section class="confirm">
		<div class="wrapper">
			<div class="login-nav">
				<router-link to="/">
					<div class="img-box login">
						<img src="../assets/images/Web-logo.png" alt="An image of our logo. Clicking on will redirect you to the home page.">
					</div>
				</router-link>
			</div>
			<!-- <h1 class="heading confirm-heading">Please confirm your order.</h1> -->
			<div class="confirm-content">
				<div class="confirm-content--order">
					<ul v-if="guest">
						<li v-for="item in guestCart" class="confirmed-item">
							<div class="confirmed-item--top" :data-item="item.id">
								<h3 class="tertiary-heading confirmed-item--name">{{ item.name }}</h3>
								<h4 class="tertiary-heading confirmed-item--quantity">x {{ item.qty }}</h4>
								<h4 class="tertiary-heading confirmed-item--price">${{ item.price }}</h4>
							</div>
							<div class="confirmed-item--bottom">
								<h4 class="primary-copy" v-if="item.desc !== item.name">{{ item.desc }}</h4>
								<h4 class="primary-copy special-instructions" v-if="item.specialInstructions">({{ item.specialInstructions }})</h4>
							</div>
						</li>
					</ul>
					<ul v-else>
						<li v-for="item in backendCart" class="confirmed-item">
							<div class="confirmed-item--top" :data-item="item.id">
								<h3 class="tertiary-heading confirmed-item--name">{{ item.name }}</h3>
								<h4 class="tertiary-heading confirmed-item--quantity">x {{ item.qty }}</h4>
								<h4 class="tertiary-heading confirmed-item--price">${{ item.price }}</h4>
							</div>
							<div class="confirmed-item--bottom">
								<h4 class="primary-copy" v-if="item.desc !== item.name">{{ item.desc }}</h4>
								<h4 class="primary-copy special-instructions" v-if="item.specialInstructions">({{ item.specialInstructions }})</h4>
							</div>
						</li>
					</ul>
					<div class="confirm-total">
						<div class="confirm-total--subtotal">
							<h2 class="subheading confirm-total-copy">Subtotal:</h2>
							<h4 class="tertiary-heading confirm-total-number">${{ subTotal }}</h4>
						</div>
						<div class="confirm-total--taxes">
							<h2 class="subheading confirm-total-copy">HST:</h2>
							<h4 class="tertiary-heading confirm-total-number">${{ hst }}</h4>
						</div>
						<div class="confirm-total--total">
							<h2 class="subheading confirm-total-copy">Total:</h2>
							<h4 class="tertiary-heading confirm-total-number">${{ total }}</h4>
						</div>
					</div>
				</div>
				<div class="confirm-content--payment">
					<form class="payment-form" @submit.prevent>
						<div v-if="locationData.pay_later === 1" class="payment-form--toggle">
							<h3 class="tertiary-heading" :class="{red: !payLater}">Pay Now</h3>
							<label for="payment-form--type" class="switch">
								<input type="checkbox" id="payment-form--type" v-model="payLater">
								<span class="slider"></span>
							</label>
							<h3 class="tertiary-heading" :class="{red: payLater}">Pay Later</h3>
						</div>
						<div class="payment-form--universal">
							<div v-if="locationData.delivery === 1" class="order-type-container">
								<label class="tertiary-heading" for="order-type">Order for: </label>
								<select v-model="orderType" id="order-type" class="order-select order-type tertiary-heading">
									<option value="delivery">Delivery</option>
									<option value="pickup">Pickup</option>
								</select>
								<span class="select-icon"><i class="fa fa-caret-down"></i></span>
							</div>
							<h5 v-if="orderType === 'delivery'" class="tertiary-heading"> *All delivery orders are cash only </h5>
							<div class="delivery-details" v-if="orderType === 'delivery'">
								<div class="delivery-details--guest" v-if="guest">
									<label for="guestAddress" class="tertiary-heading">Address:</label>
									<input type="text" id="guestAddress" class="primary-copy" v-model="guestData.address">
									<label for="guestPostal" class="tertiary-heading">Postal Code:</label>
									<input type="text" id="guestPostal" class="primary-copy" v-model="guestData.postal">
								</div>
								<div class="delivery-details--user" v-else>
									<h3 class="tertiary-heading">Delivery Details:</h3>
									<ul>
										<li class="primary-copy">Name: {{ userData.firstName + ' ' + userData.lastName }}</li>
										<li class="primary-copy">Email: {{ userData.email }}</li>
										<li class="primary-copy">Phone: {{ userData.phone }}</li>
										<li class="primary-copy">Address: {{ userData.address }}</li>
										<li class="primary-copy">Postal Code: {{ userData.postal }}</li>
									</ul>
								</div>
							</div>
							<div class="order-time-container" v-if="orderType === 'pickup'">
								<label for="orderLater" class="tertiary-heading">Pickup time: </label>
								<select v-model="orderLater" id="orderLater" class="order-select order-time tertiary-heading">
									<option value="false" selected>as soon as possible.</option>
									<option value="true">later.</option>
								</select>
								<span class="select-icon"><i class="fa fa-caret-down"></i></span>
							</div>
							<el-date-picker
								id="datePicker"
								v-if="orderLater === 'true' && orderType === 'pickup'"
								v-model="orderDate"
								type="datetime"
								placeholder="Select date and time."
								value-format="yyyy-MM-dd HH:mm:ss">
							</el-date-picker>
						</div>
						<div class="payment-form--pay-now" v-if="!payLater">
							<div class="payment-option">
								<div class="order-time-container">
									<label for="card-type" class="tertiary-heading">Paying with:</label>
									<select style="pointer-events:none" id="card-type" class="order-select card-type tertiary-heading" v-model="cardType">
										<!-- <option value="debit">Debit</option> -->
										<option value="credit" selected>Credit</option>
									</select>
									<!-- <span class="select-icon"><i class="fa fa-caret-down"></i></span> -->
								</div>

							</div>
							<!-- <iframe v-if="cardType === 'debit'" id='monerisFrame' src="https://esqa.moneris.com/HPPtoken/index.php?id=htMMNI9VEXJF3LR&css_body=background:white;&css_textbox=border-width:2px;&css_textbox_pan=width:140px;&enable_exp=0&css_textbox_exp=width:40px;&enable_cvd=0&css_textbox_cvd=width:40px;&display_labels=1" frameborder='0' width="200px" height="200px"></iframe>
							<iframe v-if="cardType === 'credit'" id='monerisFrame' src="https://esqa.moneris.com/HPPtoken/index.php?id=htMMNI9VEXJF3LR&css_body=background:white;&css_textbox=border-width:2px;&css_textbox_pan=width:140px;&enable_exp=1&css_textbox_exp=width:40px;&enable_cvd=1&css_textbox_cvd=width:40px;&display_labels=1" frameborder='0' width="200px" height="200px"></iframe> -->
							<div style="width:100%;display: flex;justify-content: center;align-items: center;">
								<iframe v-if="cardType === 'debit'" id='monerisFrame' :src="monerisDebitUrl" frameborder='0'></iframe>
								<iframe v-if="cardType === 'credit'" id='monerisFrame' :src="monerisCreditUrl" frameborder='0'></iframe>
							</div>

							<div class="order-buttons">
								<button class="place-order" @click="requestToken">Place Order</button>
								<button class="place-order" @click="editOrder">Edit Order</button>
							</div>
						</div>
						<div class="payment-form--pay-later" v-else>
							<div class="order-buttons">
								<button class="place-order" @click="handlePlaceOrder">Place Order</button>
								<button class="place-order" @click="editOrder">Edit Order</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import Orders from '@/controllers/Orders'
	import global from '@/global.js'
	import Location from '@/controllers/Location'

	export default {
		name: 'ConfirmOrder',
		data () {
			return {
				payLater: false,
				cardType: 'credit',
				orderType: 'pickup',
				orderDate: '',
				orderLater: 'false',
				guestData: {},
				error: false,
				errorTitle: '',
				errorMessage: '',
				cardToken: '',
				messages: 0,
				loading: false,
				monerisCreditUrl: '',
				monerisDebitUrl: '',
				location: global.getLocation(),
				locationData: {}
			}
		},
		created () {
			this.monerisCreditUrl = `
			https://www3.moneris.com/HPPtoken/index.php
			?id=htB1MYU2CE8NKIR
			&display_labels=2
			&css_body=background:transparent;
			&css_textbox=border-width:2px;
			&css_textbox_pan=
				width:100%;
				overflow:visible;
				height:40px;
				font-size:16px;
				margin-bottom:10px;
				border:none;
				border-bottom: 1px solid grey;
			&enable_exp=1
			&css_textbox_exp=
				width:48%;
				height:40px;
				font-size:16px;
				display:inline-block;
				float:left;
				margin-bottom:10px;
				margin-right:4%;
				border:none;
				border-bottom: 1px solid grey;
			&enable_cvd=1
			&css_textbox_cvd=
				width:48%;
				margin-left:0%;
				display:inline-block;
				height:40px;
				font-size:16px;
				border:none;
				border-bottom: 1px solid grey;
			`

			this.monerisDebitUrl = `
			https://www3.moneris.com/HPPtoken/index.php
			?id=htB1MYU2CE8NKIR
			&display_labels=2
			&css_body=background:transparent;
			&css_textbox=border-width:2px;
			&css_textbox_pan=
				width:100%;
				overflow:visible;
				height:40px;
				font-size:16px;
				margin-bottom:10px;
				border:none;
				border-bottom: 1px solid grey;
			`
		},
		mounted () {
			this.getLocationData()
		},
		computed: {
			backendCart () {
				return this.$root.backendCart
			},
			// if user is guest there is no backend cart, and so we must pull item data from frontend cart
			guestCart () {
				let guestCart = []
				if (!this.backendCart.length) {
					guestCart = this.$root.cart
				}
				return guestCart
			},
			pickupLater () {
				if (this.orderLater === 'false') {
					return false
				} else {
					return true
				}
			},
			userData () {
				return this.$root.userData
			},
			guest () {
				if (this.$root.guest) {
					return true
				} else {
					return false
				}
			},
			subTotal () {
				let subTotal = 0
				if (this.guest) {
					this.guestCart.forEach((item) => {
						let price = parseFloat(item.price) * parseFloat(item.qty)
						subTotal = subTotal + price
					})
				} else {
					this.$root.backendCart.forEach((item) => {
						let price = parseFloat(item.price) * parseFloat(item.qty)
						subTotal = subTotal + price
					})
				}
				return subTotal.toFixed(2)
			},
			hst () {
				let subTotal = parseFloat(this.subTotal)
				let taxRate = subTotal < 4 ? 0.5 : 0.13
				let hst = taxRate * subTotal
				return hst.toFixed(2)
			},
			total () {
				let hst = parseFloat(this.hst)
				let subTotal = parseFloat(this.subTotal)
				let total = subTotal + hst
				return total.toFixed(2)
			},
			utcTime () {
				let utcTime = ''
				if (this.orderDate) {
					let date = new Date(this.orderDate)
					let utcArr = [
						date.getUTCFullYear(),
						date.getUTCMonth() + 1,
						date.getUTCDate(),
						date.getUTCHours(),
						date.getUTCMinutes(),
						date.getUTCSeconds()
					]
					let formattedUtcArr = []
					utcArr.forEach((entry) => {
						entry = entry.toString()
						if (entry.length === 1) {
							entry = '0' + entry
						}
						formattedUtcArr.push(entry)
					})
					utcTime = `${formattedUtcArr[0]}-${formattedUtcArr[1]}-${formattedUtcArr[2]} ${formattedUtcArr[3]}:${formattedUtcArr[4]}:${formattedUtcArr[5]}`
				}
				return utcTime
			}
		},
		methods: {
			getLocationData () {
				Location.getLocation().then(response => {
					this.locationData = response.payload
				}).catch(e => {})
			},
			requestToken () {
				if (this.guest && this.orderType === 'delivery') {
					if (this.guestData.address && this.guestData.postal) {
						let monFrameRef = document.getElementById('monerisFrame').contentWindow
						monFrameRef.postMessage('', 'https://www3.moneris.com/HPPtoken/index.php')
						window.addEventListener('message', this.receiveToken, false)
						console.log('Token requested')
						return false
					} else {
						this.error = !this.error
						this.$message.error('Address and postal code are required for delivery.')
						// this.errorTitle = 'Failed to place order.'
						// this.errorMessage = 'Address and postal code are required for delivery.'
					}
				} else {
					let monFrameRef = document.getElementById('monerisFrame').contentWindow
					monFrameRef.postMessage('', 'https://www3.moneris.com/HPPtoken/index.php')
					window.addEventListener('message', this.receiveToken, false)
					console.log('Token requested')
					return false
				}
			},
			receiveToken (e) {
				console.log('message received from', e.origin)
				// this.$message.info('Validating payment info')
				this.messages = 1
				// eslint-disable-next-line
				let response = eval('(' + e.data + ')')
				this.cardToken = response.dataKey
				if (this.cardToken !== undefined) {
					// this.$message.success('Payment info validated')
					this.handlePlaceOrder(this.cardToken)
				} else {
					alert('error processing your payment. please try again.')
					this.$message.error('Payment info is not valid')
				}
				console.log('Card Token: ' + this.cardToken)
				window.removeEventListener('message', this.receiveToken, false)
			},
			handlePlaceOrder (paymentToken) {
				console.log('handle place order was called')
				let guestOrderPayLater = {
					payLater: 1,
					pickuplater: this.pickupLater,
					pickupdatetime: this.utcTime,
					checkoutType: 'guest',
					user: this.$root.guestData,
					items: this.guestCart
				}

				let guestOrderPayNow = Object.assign({}, guestOrderPayLater, {payLater: 0, token: paymentToken})

				let userOrderPayLater = {
					payLater: 1,
					pickup: this.pickupLater,
					pickupdatetime: this.utcTime,
					checkoutType: 'registered',
					user: this.$root.userData,
					cartId: this.$root.cartId
				}

				let userOrderPayNow = Object.assign({}, userOrderPayLater, {payLater: 0, token: paymentToken})

				if (this.guest && this.payLater) {
					console.log('placing guestOrderPayLater', guestOrderPayLater)
					this.placeOrder(guestOrderPayLater)
				}
				if (this.guest && !this.payLater) {
					console.log('placing guest order pay now')
					this.placeOrder(guestOrderPayNow)
				}
				if (!this.guest && this.payLater) {
					console.log('placing user order pay later')
					this.placeOrder(userOrderPayLater)
				}
				if (!this.guest && !this.payLater) {
					console.log('placing user order pay now')
					this.placeOrder(userOrderPayNow)
				}
			},
			placeOrder (obj) {
				this.loading = true
				const items = obj.items.map((item) => {
					return {
						'item_id': item.id,
						'item_qty': item.qty,
						'base_price': item.price,
						'actual_price': item.price,
						'item_order': 1,
						'modifiers': []
					}
				})
				let cartObj = {
					'location_id': this.location,
					'pickup_later': obj.pickupLater, // bool
					'pay_later': obj.payLater, // 1 or 0
					'pickupdatetime': obj.pickupdatetime,
					'checkout_type': obj.checkoutType, // 'guest'
					'payment_token': obj.token,
					'cart_type': 'regular',
					'gateway_name': 'moneris',
					'user': {
						'first_name': obj.user.firstName,
						'last_name': obj.user.lastName,
						'email': obj.user.email,
						'phone': obj.user.phone,
						'brand_id': this.$root.brandId
					}
				}
				if (obj.checkoutType === 'guest') {
					cartObj.items = items
				} else if (obj.checkoutType === 'registered') {
					cartObj.cart_id = obj.cartId
				}
				Orders.placeOrder(cartObj).then(response => {
					this.$message.success('Successfully placed order!')
					this.$router.push({
						name: 'Success',
						params: {
							orderNumber: response.payload.external_id,
							userEmail: obj.user.email
						}
					})
				}).catch(e => {
					this.$message.error('Error: ' + e.responseJSON.message)
					console.log('error placing order')
				})
			},
			editOrder () {
				this.$emit('editFromConfirmation')
				this.$router.push({ name: 'Order', params: {cartOpenedRemotely: true} })
			},
			closeError () {
				this.error = !this.error
			}
		}
	}
</script>

<style lang='scss' scoped>
	@import '../assets/css/main';

	.confirm {
		padding: 0 0 5% 0;
	}

	.confirm-heading {
		margin-bottom: 10%;
	}

	.confirm-content {
		display: flex;
		justify-content: space-between;
		@media (max-width: 768px) {
			flex-direction: column;
		}
		.confirm-content--order, .confirm-content--payment {
			width: 50%;
			@media (max-width: 768px) {
				width: 90%;
				margin: 0 auto;
			}
		}
		.confirm-content--order {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			padding-right: 5%;
			border-right: 1px solid black;
			@media (max-width: 768px) {
				border-right: none;
				border-bottom: 1px solid black;
				padding-bottom: 5%;
			}
		}
		.confirm-content--payment {
			padding-left: 5%;
			border-left: 1px solid black;
			@media (max-width: 768px) {
				border-left: none;
				border-top: 1px solid black;
				padding-top: 5%;
			}
		}
	}

	.confirm-total {
		display: flex;
		flex-direction: column;
		.subheading {
			margin-bottom: 0;
		}
		div {
			display: grid;
			align-items: center;
			grid-template-columns: 50% 25% 25%;
			grid-template-areas: 'copy . number';
			margin-bottom: 2%;
		}
		.confirm-total-copy {
			grid-area: copy;
			text-align: left;
			color: black;
		}
		.confirm-total-number {
			grid-area: number;
			text-align: right;
			font-size: 2.4rem;
		}
	}

	.confirm-total--total {
		.confirm-total-number, .confirm-total-copy {
			color: $primary-color;
			font-size: 4rem;
		}
		.confirm-total-number {
			border-top: 3px solid black;
		}
	}

	.confirmed-item {
		display: flex;
		flex-direction: column;
		margin-bottom: 2%;
		border-bottom: 1px solid lighten(grey, 20%);
		.tertiary-heading {
			font-size: 2.4rem;
		}
	}

	.confirmed-item--top {
		display: grid;
		align-items: center;
		grid-template-columns: 50% 25% 25%;
		grid-template-areas: 'item qty price';
		text-align: right;
		.confirmed-item--name {
			grid-area: item;
			text-align: left;
		}
		.confirmed-item--quantity {
			grid-area: qty;
		}
		.confirmed-item--price {
			grid-area: price;
		}
	}

	.payment-form {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		width: 100%;
		height: 100%;
		.tertiary-heading {
			font-size: 2.4rem;
		}
		.red {
			color: $primary-color;
			transition: color .25s;
		}
		.payment-form--toggle {
			display: flex;
			justify-content: center;
			align-items: center;
			border-bottom: 1px solid grey;
			margin-bottom: 5%;
			.switch {
				margin: 0 2%;
			}
		}
	}

	.select-icon {
		font-size: 2.4rem;
		color: $primary-color;
	}

	.payment-form--universal {
		display: flex;
		flex-direction: column;
		margin-bottom: 5%;
	}

	.order-type-container, .order-time-container {
		display: grid;
		grid-template-columns: 40% 55% 5%;
		grid-template-areas: 'label select caret';
		align-items: center;
		margin-bottom: 2%;
		label {
			grid-area: label;
		}
		.order-select {
			grid-area: select;
			text-align: right;
			color: $primary-color;
		}
		.select-icon {
			grid-area: caret;
		}
	}

	.order-time-container {
		margin-bottom: 5%;
	}

	.delivery-details {
		margin-bottom: 5%;
	}

	.el-date-editor.el-input {
		width: 60%;
		transform: translateX(66.67%);
	}

	.el-input__inner {
		border: 1px solid $primary-color;
	}

	.el-input__prefix {
		color: $primary-color;
	}

	.order-buttons {
		display: flex;
		justify-content: space-around;
		width: 100%;
		button {
			width: 45%;
		}
	}

	.payment-form--pay-later {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-end;
	}

	.pay-now--select {
		border: none;
		appearance: none;
		background: white;
		@include primary-font(1.8rem, 400);
	}

	.delivery-details--user {
		li {
			margin-left: 5%;
		}
	}

	.delivery-details--guest {
		display: flex;
		flex-direction: column;
	}

	.place-order {
		@include secondary-button;
		color:white!important;
		background-color:#D00016 !important;
	}

</style>



// WEBPACK FOOTER //
// src/components/ConfirmOrder.vue